const resource = {
    resource_identifier_in_use: 'O identificador de API {{indicator}} já está em uso',
    cannot_delete_management_api: 'Não é possível excluir a API de gerenciamento da Logto.',
    cannot_modify_management_api: 'Não é possível modificar a API de gerenciamento da Logto.',
};
export default Object.freeze(resource);
